module.exports = __webpack_public_path__ + "static/media/br-ap.f3bd6912.svg";